import { ReactNode } from 'react';

import { type DataTableColumnDef } from '@column/ui';

export const getColumnVisibility = <T>(columns: DataTableColumnDef<T>[], visibleColumns: string[] | undefined) => {
  return columns.reduce(
    (acc, column) => {
      acc[column.accessor as string] = visibleColumns?.includes(column.accessor as string) ?? true;
      return acc;
    },
    {} as Record<string, boolean>
  );
};

export const withAmountFooter = <T>(columns: DataTableColumnDef<T>[], footer: ReactNode): DataTableColumnDef<T>[] =>
  columns.map((column) => (column.accessor === 'amount' ? { ...column, footer } : column));
